/**
 * Messaging-channel health API service layer.
 *
 * Reads the state of the outbound channels — the two WhatsApp (UltraMsg)
 * instances and the SMS gateway. Admin-only; the token is attached by the
 * axios interceptor in `api/index.js`.
 */
import { api } from "api";
import { getMessagingHealth } from "api/apiURLs";

/**
 * Current channel state.
 *
 * The server answers from the health cron's last observation (at most five
 * minutes old) so opening the page costs nothing. Pass `refresh` to force a
 * live probe — used by the refresh button, which is what you press after
 * re-linking an instance.
 *
 * @param {{ refresh?: boolean }} [options]
 */
export const fetchMessagingHealth = async ({ refresh = false } = {}) => {
    const response = await api.get(`${getMessagingHealth}${refresh ? "?refresh=1" : ""}`);
    return response.data;
};
